import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { EventOrganizer } from 'types/event_organizers.types';

type ListCurrentUserPaginatedEventOrganizersInput = {
  searchText?: string | null;
  page?: number;
  perPage?: number;
};

type PaginatedEventOrganizers = {
  items: EventOrganizer[];
  page: number;
  pages: number;
  perPage: number;
  total: number;
};

const LIST_CURRENT_USER_PAGINATED_EVENT_ORGANIZERS_QUERY = gql`
  query ListCurrentUserPaginatedEventOrganizers(
    $searchText: String
    $page: Int = 1
    $perPage: Int = 20
  ) {
    paginatedEventOrganizers(searchText: $searchText, page: $page, perPage: $perPage) {
      items {
        name
        email
      }
      page
      pages
      perPage
      total
    }
  }
`;

type UpdateEventOrganizerInput = {
  eventId: number;
  name: string;
  email: string;
};

type UpdateEventOrganizerResponse = {
  ok: boolean;
  event: {
    id: number;
  };
};

const UPDATE_EVENT_ORGANIZER_MUTATION = gql`
  mutation UpdateEventOrganizer($input: UpdateEventOrganizerInput!) {
    updateEventOrganizer(input: $input) {
      ok
      event {
        id
      }
    }
  }
`;

const eventOrganizersApi = {
  list: async ({
    searchText,
    page,
    perPage
  }: ListCurrentUserPaginatedEventOrganizersInput): Promise<PaginatedEventOrganizers> => {
    return gqlClient
      .request<{ paginatedEventOrganizers: PaginatedEventOrganizers }>(
        LIST_CURRENT_USER_PAGINATED_EVENT_ORGANIZERS_QUERY,
        { searchText, page, perPage }
      )
      .then((res) => res.paginatedEventOrganizers);
  },
  update: async ({
    eventId,
    name,
    email
  }: UpdateEventOrganizerInput): Promise<UpdateEventOrganizerResponse> => {
    return gqlClient
      .request<{ updateEventOrganizer: UpdateEventOrganizerResponse }>(
        UPDATE_EVENT_ORGANIZER_MUTATION,
        { input: { eventId, name, email } }
      )
      .then((res) => res.updateEventOrganizer);
  }
};

export { eventOrganizersApi };
